// 2P AI — marchio orizzontale: piastrella bianca con la girandola + "2P AI" (AI in accento) + "CRM AI".
import { Mark } from './Mark';

export function Brand() {
  return (
    <div className="brand">
      <div className="mark"><Mark /></div>
      <div>
        <h1>2P&nbsp;<span className="ai">AI</span></h1>
        <div className="sub">CRM AI</div>
      </div>
    </div>
  );
}
